import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  radioButton: {
    width: 20,
    height: 20
  },
  label: {
    marginTop: 2
  }
};

export const RadioButton = ({ name, label, checked, onChange }) => {

  return (
    <div style={styles.container}>
      <input
        type="radio"
        name={name}
        value={name}
        checked={checked}
        style={styles.radioButton}
        onChange={(e) => { onChange && onChange(e); }}
      />
      <div style={styles.label}>
        {label}
      </div>
    </div>
  );
};

RadioButton.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func
};
